var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 74,
    viewBox: "0 0 75 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 75,
    height: 74,
    rx: 8,
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_2536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.6678 55C33.5277 55 33.3859 54.972 33.2505 54.9136C32.7765 54.7092 32.5202 54.1918 32.6446 53.6909L36.2112 39.3346H26.6016C26.2538 39.3346 25.9283 39.1632 25.7316 38.8762C25.535 38.5893 25.4924 38.2239 25.6179 37.8994L32.6676 19.6742C32.8247 19.2679 33.2155 19 33.6512 19H43.3515C43.7079 19 44.0402 19.18 44.235 19.4785C44.4296 19.7771 44.4604 20.1538 44.3167 20.4799L40.1423 29.9552H48.3984C48.7841 29.9552 49.139 30.1658 49.324 30.5043C49.5089 30.8428 49.4943 31.2553 49.2858 31.5798L34.5557 54.5151C34.3565 54.8253 34.0177 55 33.6678 55ZM28.1404 37.2253H37.5599C37.8844 37.2253 38.1908 37.3748 38.3907 37.6303C38.5906 37.8859 38.6617 38.2194 38.5834 38.5344L36.2312 48.0029L46.4675 32.0645H38.5251C38.1687 32.0645 37.8364 31.8845 37.6417 31.586C37.447 31.2874 37.4162 30.9107 37.56 30.5846L41.7344 21.1094H34.374L28.1404 37.2253Z",
    fill: "#040505"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_2536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(19.5 19)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstant);
export default __webpack_public_path__ + "static/media/instant.d64b3c5ebf1234774f77ef96a22edbe0.svg";
export { ForwardRef as ReactComponent };